import clsx from 'clsx';
import styles from './StatusChip.module.scss';
import type { ReconStatus } from '../../../../../store/reconciliations/types';

const STATUS_LABEL: Record<ReconStatus, string> = {
    RECONCILED: 'Reconciled',
    PARTIAL: 'Partial Reconciled',
    NOT_RECONCILED: 'Not Reconciled',
    NA: 'N/A',
    ANCHOR: 'Anchor',
};

const STATUS_CLASS: Record<ReconStatus, string> = {
    RECONCILED: styles.Green,
    PARTIAL: styles.Yellow,
    NOT_RECONCILED: styles.Red,
    NA: styles.NotAvailable,
    ANCHOR: styles.NotAvailable,
};

interface StatusChipProps {
    status: ReconStatus;
}

function StatusChip({ status }: Readonly<StatusChipProps>) {
    return (
        <span className={clsx(styles.StatusChip, STATUS_CLASS[status])}>
            <span className={styles.Dot} />
            {STATUS_LABEL[status]}
        </span>
    );
}

export default StatusChip;
